import {Component} from 'react';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import React from "react";
import { calcMonthlyIncome } from '../../objects/CommonUse/calcMonthlyIncome';
import { findRemoveTableItem } from '../../objects/AssetsExpenses/find_remove_table_item';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import SavingsGeneralDisplay from './savings/savings_general_display';
import SavingsSetupIntro from './savings/text/savings_setup_intro_text';
import TextWithLearnMoreButton from '../shared-components/text_with_learnMore_button';
import ConfigFile from '../../datasets/config_file';
import config from '../../config';
import FriendDisplayModal from '../shared-components/friend_display_modal';
import buildUrl from '../../objects/CommonUse/build_URL';
import createEventTrackerUpdateObject from '../../objects/CommonUse/create_eventTracker_update_object';
import SetupSavingsCard from './savings/setup_savings_card';
import SetupSavingsModal from './savings/setup_savings_modal';
import editInputAmounts from './savings/objects/edit_input_amounts';
import createSavingsInfoArr from './savings/objects/create_savings_info_arr';
import createSavingsUpdateObj from './savings/objects/create_savings_update_obj';
import Savings401KIntro from './savings/text/savings_401k_intro_text';
import getCompanyMatchRate from './xMoneyBuilderObjects/get_company_match_rate';
import SavingsChangeConfirmModal from './savings/savings_change_confirm_modal';
import calcDepositPercent from './xMoneyBuilderObjects/calc_deposit_percent';
import getCurrentPriceArr from './xMoneyBuilderObjects/get_current_price_arr';
import determineTransferFeeAndText from './xMoneyBuilderObjects/determine_transfer_fee_and_warning_text';
import reformatTotalSavingsArr from './xMoneyBuilderObjects/reformat_total_savings_arr';
import ConductorDashboardDataCard from './conductor_dashboard_data_card';
import determineSavingsLevel from './savings/objects/determine_savings_level';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    retirementPriceArr: state.retirementPriceArr,
    prevProcess: state.prevProcess,
    companyMatchRate: state.companyMatchRate,
    savingInterestRates: state.savingInterestRates
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class SetupSavings extends Component {
        constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state={
            headers: setHeadersForFetch(),  
            updateEnabled: false,   
            displayInstructions: false,
            defaultClass: "font-weight-bold ",
            openFriendModal: false,
            subProcess: "setupsavingsModal",
            environment: config.dataURL.currentEnv,
            eventTracker: ConfigFile.general.eventTracker,
            rerender: null,
            step: "change",
            openSavingsModal: false,
            openConfirmModal: false,
        } 
        this.scrollRef = React.createRef();
        this.dataChanged = false;
        this.accountTypeExists = false;
        this.policyOptionsArr = [];
        this.messageArr = [];
        this.savingSummaryArr = [];
        this.previousProcess = "";
        this.transferFeeObj = {transferFeeDisplay: false}
        this.savePreviousProcess();
        this.initializeFields();
    }
    
    savePreviousProcess(){
        this.previousProcess = this.props.prevProcess;
    }

    initializeFields(){
        let monthlySalaryObj = findRemoveTableItem(this.moneyBuildInfo.gameData.assetTable,
            "salary", false);
        this.monthlySalary = monthlySalaryObj.assetAmt;
        this.currentCash = this.moneyBuildInfo.gameData.currentCash;
        this.currentCashDisplay = JSON.parse(JSON.stringify(this.moneyBuildInfo.gameData.currentCash));
        let incomeObj = calcMonthlyIncome(this.moneyBuildInfo.gameData.assetTable,
            this.moneyBuildInfo.gameData.expenseTable, this.moneyBuildInfo.gameData.loanTable);
        this.monthlyIncome = incomeObj.income;
        let unlockedFeature = 
            this.moneyBuildInfo.gameData.unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
        this.savingsLevel = unlockedFeature.level;
    
        const friendsMetArr = this.moneyBuildInfo.gameData.friendList.filter(elem => elem.introDate !== "");
        if (friendsMetArr.length === 0){
            this.friendsMet = false;
        }else{
            this.friendsMet = true;
        }
    }
    
    prepareForDisplay(){
        this.transferFeeObj = {transferFeeDisplay: false}
        this.savingsClass = this.props.savingsClass;
        this.title = "Setup Savings Account(s)";
        if (this.savingsClass === "retirement"){
            this.title = "Setup Retirement 401(k) Accounts";
        }
        let savingsArr = [];
        this.newSavingsSw = true;
        this.companyMatchRate = 0;
        this.accountTypeExists = false;
        if (this.moneyBuildInfo.savingsInfo.gameID){
            this.newSavingsSw = false;
            this.companyMatchRate = this.moneyBuildInfo.savingsInfo.companyMatchRate;
            if (this.moneyBuildInfo.savingsInfo.savingsArr &&
                this.moneyBuildInfo.savingsInfo.savingsArr.length > 0){
                savingsArr = this.moneyBuildInfo.savingsInfo.savingsArr;
                const checkForSavingsClass = savingsArr.find(elem => elem.savingsClass === this.savingsClass);
                if (checkForSavingsClass){
                    this.accountTypeExists = true;
                }
            }
        }
        if (+this.companyMatchRate === 0){
            const companyMatchRate = this.props.companyMatchRate;
            if (+companyMatchRate === 0){
                this.companyMatchRate = getCompanyMatchRate();
            }else{
                this.companyMatchRate = companyMatchRate;
            }
            this.props.setInfoRedux(this.companyMatchRate, "companyMatchRate");
            this.props.setMoneyBuildInfo(this.companyMatchRate, "companyMatchRate");
            
        }
        const retirementPriceArr = this.props.retirementPriceArr;
        const retirementCurrentPriceArr = 
            retirementPriceArr.filter(elem => elem.monthNbr === this.props.currentMonthNbr);
        const savingsInfoObj = createSavingsInfoArr(savingsArr, 
            this.moneyBuildInfo.gameData.currentGameDate, this.savingsClass,
            retirementCurrentPriceArr, this.companyMatchRate, this.moneyBuildInfo.gameData.gameNbrMonths,
            this.props.savingInterestRates);
        this.savingsInfoArr = savingsInfoObj.savingsInfoArr;
        this.totalSavings = savingsInfoObj.totalSavings;
        this.totalSavingsArr = savingsInfoObj.totalSavingsArr;
        this.savingSummaryArr = reformatTotalSavingsArr(this.totalSavingsArr);
        let maxIndx = this.savingSummaryArr.length - 1;
        this.totalGainLoss = (this.savingSummaryArr[maxIndx].totalGainLoss * -1);
        this.totalMonthlyAmt = savingsInfoObj.totalMonthlyAmt;
        this.depositPercent = savingsInfoObj.depositPercent;
        this.totalTransferAmt = savingsInfoObj.totalTransferAmt;
        // transfer amounts are negative amounts in the tranArr
        this.totalDepositAmt = +savingsInfoObj.totalDeposited;
        //  used to restore CD List if changes made due to transfer & other
        this.summaryData = {
            currentGameDate: this.moneyBuildInfo.gameData.currentGameDate,
            currentCash: this.currentCash,
            monthlySalary: this.monthlySalary, 
            totalSavings: this.totalSavings,
            monthlyIncome: this.monthlyIncome, 
            monthlySavingsAmt: this.totalMonthlyAmt,
            totalDeposited: this.totalDepositAmt, 
            totalTransferAmt: this.totalTransferAmt};
        if (this.savingsClass === "bank"){
            this.totalInterestEarned = savingsInfoObj.totalInterestEarned;
            this.initialCDList = savingsInfoObj.CDList;
            this.CDList = savingsInfoObj.CDList;
            this.summaryData = {...this.summaryData, totalInterestEarned: this.totalInterestEarned};
        }else{
            this.totalMatchAmt = +savingsInfoObj.totalMatchAmt;
            this.summaryData = {...this.summaryData, totalMatchAmt: this.totalMatchAmt
            };
        }
        this.introText();
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.props.setMoneyBuildInfo(savingsInfoObj.interestRateArr, "savingInterestRates");
    }    

    introText(){
        if (this.savingsClass === "bank"){
            this.introText1 = SavingsSetupIntro.summaryText;
            this.introText2 = SavingsSetupIntro.moreInformation;
        }else{
            this.introText1 = Savings401KIntro.summaryText;
            this.introText2 = Savings401KIntro.moreInformation;
        }
    }
     
    displayFriendModal(){
        if (this.savingsClass === "bank"){
            this.askAFriendInfo = {topic: "setupSavings"};
        }else{
            this.askAFriendInfo = {topic: "setup401K"}
        }
        this.setState({openFriendModal: true});
    }
    
    closeFriendModal(){
        this.setState({openFriendModal: false});
    }
       
    saveDepositAmounts(savingObj){
        this.validAmounts = true;
        const fieldName=savingObj.fieldName;
        const indx = this.savingsInfoArr.findIndex(elem => elem.savingsType === savingObj.savingsType);
        this.savingsInfoArr[indx][fieldName] = savingObj.value;  
        this.checkIfDataUpdated(indx);
        if (fieldName === "monthlyDepositAmt" && savingObj.savingsClass === "retirement"){
            this.summaryData.monthlySavings = calcDepositPercent(this.savingsInfoArr);
        }
        if (fieldName === "newTransferAmt"){
            const savingInfoObj = this.savingsInfoArr[indx];
            this.determineTransferFee(savingInfoObj)
        }
        if (savingObj.savingsClass === "bank"){
            this.CDList = JSON.parse(JSON.stringify(this.initialCDList));
        }
        this.setState({step: "change"});
    }

    determineTransferFee(savingInfoObj){
        const startDateMonth = savingInfoObj.startDate.split('-')[1];
        const gameMonth = this.moneyBuildInfo.gameData.currentGameDate.split('-')[1];
        let monthOK = false;
        if (startDateMonth === gameMonth){
            monthOK = true;
        }
        this.transferFeeObj = determineTransferFeeAndText(savingInfoObj.savingsType, 
            savingInfoObj.savingsClass, monthOK, savingInfoObj )
    }

    checkIfDataUpdated(indx){
        if (this.savingsInfoArr[indx].oneTimeDepositAmt > 0 ||
            this.savingsInfoArr[indx].monthlyDepositAmt !== this.savingsInfoArr[indx].currentMonthlyAmt ||
            this.savingsInfoArr[indx].newTransferAmt > 0 ){
                this.savingsInfoArr[indx].updated = true;
        }else{
                this.savingsInfoArr[indx].updated = false;
        }
    }

    updateCDList(CDObj){
        const CDIndx = this.CDList.findIndex(elem => elem.date === CDObj.date);
        this.CDList[CDIndx].newAutoRollover = CDObj.autoRollover;
        if (this.CDList[CDIndx].autoRollover !== this.CDList[CDIndx].newAutoRollover){
            const savingsIndx = 
                this.savingsInfoArr.findIndex(elem => elem.savingsType === "CD");
            if (savingsIndx !== -1){
                this.savingsInfoArr[savingsIndx].updated = true;
            }
        }
    }
   
    amountsSubmitted(){
        this.setState({openSavingsModal: false});
        this.dataChanged = false;
        this.checkIfSomethingHasChanged();
        this.fieldErrors = false;
        if (this.dataChanged === true){
            this.editAmounts();
            if (this.fieldErrors === true){
                this.messageArr.push("Click on the 'Make Changes' button to correct the error(s).")
                this.messageClass = "text-right text-danger mr-4";
                this.setState({step: "change"});
            }else{
                this.messageClass = "font-weight-bold text-right";
                this.messageArr = ["Entries valid.  Click Confirm Change to save changes."]
                this.setState({step: "confirm"});
            }
        }else{
            this.messageClass = "font-weight-bold text-right";
            this.messageArr = ["No entries have been made."]
            this.setState({step: "change"});
        }
    }

    checkIfSomethingHasChanged(){
        for (let i=0; i<this.savingsInfoArr.length; i++){
            if (this.savingsInfoArr[i].updated === true){
                this.dataChanged = true;
                this.props.onChangesNotConfirmed(true);
            }
        }
    }

    editAmounts(){
        const editAmountObj = editInputAmounts(this.savingsInfoArr, this.currentCash,
            this.monthlyIncome, this.totalSavings);
        this.fieldErrors = editAmountObj.fieldErrors;
        this.messageArr = editAmountObj.messageTextArr;
        this.totalOneTimeAmt = editAmountObj.totalOneTimeAmt;
        this.totalTransferAmt = editAmountObj.totalTransferAmt;
        this.totalNewMonthlyAmt = editAmountObj.totalNewMonthlyAmt;
        this.totalTransferFee = editAmountObj.totalTransferFee;
        this.summaryData.totalDeposited -= this.totalTransferFee;
        this.summaryData = {...this.summaryData,  totalOneTimeAmt: this.totalOneTimeAmt, 
            newMonthlyAmt: this.totalNewMonthlyAmt, totalTransferAmt: this.totalTransferAmt, 
            totalTransferFee: this.totalTransferFee }
        this.setState({rerender: !this.state.rerender});
    }

    goToNextProcess(newProcess){
        if (newProcess){
            this.props.onNavigate(newProcess);
        }
    }

    displaySavingsModal(savingsType){
        this.selectSavingsInfo=this.savingsInfoArr.find(elem => elem.savingsType === savingsType);
        this.setState({openSavingsModal: true});
    }

    closeSavingsModal(){
        this.setState({openSavingsModal: false});
    }
   
    openSavingsConfirmModal(){
        this.setState({openConfirmModal: true});
    }

    closeSavingsConfirmModal(){
        this.props.onChangesNotConfirmed(false);
        this.setState({openConfirmModal: false});
         if (this.scrollRef.current) {
            this.scrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
        }
    }

    render() {
        if (this.savingsClass !== this.props.savingsClass){
            this.prepareForDisplay();
        }
        this.summaryDisplay = this.savingSummaryArr.map((portfolioItem, index) =>
            <ConductorDashboardDataCard key={index} portfolioInfo={portfolioItem}
                displayPercent={true}
                summaryLevel={"subType"}
            />
        );
        this.savingsInfo = this.savingsInfoArr.map((savings, index) =>
            <SetupSavingsCard key={index} savingsInfo={savings} 
                callingProcess={"setupSavings"} savingsClass={this.savingsClass}
                currentGameDate={this.moneyBuildInfo.gameData.currentGameDate}
                displaySavingsModal={(savingsType) => this.displaySavingsModal(savingsType)}
            />
        );
        const displayMessages = this.messageArr.map((msg, index) => (
            <div key={index} className="">
                {msg}
            </div>
        ));
        this.classSize = "col-sm-8 mt-1";
       
    return <>
        <div className={this.classSize}>
            <div className="card mt-2 rounded-corners-lg height-max moneyBuilder-text-size">
            <h4 className="text-center mt-4">{this.title}</h4>
            {/* Container with fixed height and column layout */}
            <div ref={this.scrollRef} className="overflow-scroll mx-4 mb-5" style={{ maxHeight: "70vh" }}>
                <div style={{ padding: '16px' }}>
                    <TextWithLearnMoreButton
                        initialStateCollapse={this.accountTypeExists}
                        text1={this.introText1}
                        text2={this.introText2}
                    />
              
                </div>
                    <div className="mx-0 mt-0">
                        <SavingsGeneralDisplay
                            savingsClass={this.savingsClass}
                            step={this.state.step}
                            fieldErrors={this.fieldErrors}
                            summaryData={this.summaryData}
                            callingProcess={"main"}
                        />
                    </div>
            {this.accountTypeExists   ?
                <>
                <table className="table table-no-space table-hover align-middle text-center mt-2">
                    <tbody>
                        <tr>
                            <th className="text-center table-header-middle">Account Type</th>
                            <th className="text-center">Out-of-Pocket<br/> Amount</th>
                            <th className="text-center table-header-middle">Current Balance</th>
                            <th className="text-center table-header-middle">Net Change</th>
                            <th className="text-center table-header-middle">Rate of Return</th>
                        </tr>
                        {this.summaryDisplay}
                    </tbody>
                </table>
                {this.savingsClass === "retirement"  ?
                    <div className="mx-3">
                        <b>Note:</b>&nbsp;&nbsp;You might see a small 1 cent difference between your contribution 
                        amount and the current balance.  This is due to rounding when purchasing investment shares. 
                        Because shares are bought at exact market prices, your contribution is used to buy 
                        as many whole or fractional shares as possible, and any remaining fraction of a 
                        cent is held as uninvested cash.
                    </div>
                :
                    null
                }
                </>
            :
                null
             }
            {this.state.step === 'confirm' && (
                <div className="ml-4 mt-2">
                    <div>
                        <b>If the information displayed is correct, click the "Confirm
                        Change" button ...OR... you can make changes to the amounts and resubmit.</b>
                    </div>
                </div>
            )}

           <div>
                <div className="mt-4 mx-4">
                    {this.savingsInfo}
                </div>
            </div>
           
            {this.state.openSavingsModal  ?
                <SetupSavingsModal
                    show={this.state.openSavingsModal}
                    CDList={this.CDList}
                    savingsClass={this.savingsClass}
                    gameDate={this.moneyBuildInfo.gameData.currentGameDate}
                    savingsInfo = {this.selectSavingsInfo}
                    summaryData={this.summaryData}
                    transferFeeObj={this.transferFeeObj}
                    onClose={() => this.closeSavingsModal()}
                    saveDepositAmounts={(savingObj) => this.saveDepositAmounts(savingObj)}
                    amountsSubmitted={() => this.amountsSubmitted()}
                    updateCDList={(CDObj) => this.updateCDList(CDObj)}
                />
            :
                null
            }
            {this.state.openFriendModal && (
                <FriendDisplayModal
                    show={this.state.openFriendModal}
                    title={""}
                    gameProcess="GameViews"
                    askAFriendInfo={this.askAFriendInfo}
                    friendData={this.state.emptyArr}
                    onClose={() => this.closeFriendModal()}
                    gameInfo={() => this.props.moneyBuildInfo()}
                    />
            )}
            {this.state.openConfirmModal && (
                <SavingsChangeConfirmModal
                    show={this.state.openConfirmModal}
                    savingsClass={this.savingsClass}
                    savingsInfoArr={this.savingsInfoArr}
                    CDList={this.CDList}
                    currentCash={this.currentCashDisplay}
                    monthlyIncome={this.monthlyIncome}
                    onClose={() => this.closeSavingsConfirmModal()}
                    onConfirm={() => this.amountsConfirmed()}
                />
            )}
        </div>
           {/* Outer padded container to prevent overflow near rounded edges */}
            <div className=" py-2">
               <div className="d-flex align-items-center"
                    style={{ width: "fit-content", marginLeft: "auto", marginRight: "auto" }} >
                {/* Messages */}
                <div className={`${this.messageClass} mr-3`}>
                    {displayMessages}
                </div>
                {/* Buttons */}
                {this.state.step === "confirm" && (
                    <div>
                     <svg className="right-pointing-arrow" viewBox="0 0 24 24">
                        <path d="M4 12h12M12 6l6 6-6 6"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"/>
                    </svg>

                        <Button
                            variant="primary"
                            className={this.friendsMet ? "mr-3" : ""}
                            onClick={() => this.openSavingsConfirmModal()} >
                                Review/Confirm Change
                        </Button>
                    </div>
                )}
                {this.friendsMet && (
                    <Button
                        variant="info"
                        onClick={() => this.displayFriendModal()} >
                            Ask a Friend
                    </Button>
                )}
                </div>
            </div>
        </div>
        </div>
    </>
    }

componentDidMount(){
    this._isMounted = true;
    if (this._isMounted === true){
        if (this.newSavingsSw === true){
            this.setState({displayInfo: true});
        }else{
            this.setState({displayInfo: false});
        }
    }
}
    
amountsConfirmed(){
    if (this.savingsClass === "retirement"){
        this.currentPriceArr = getCurrentPriceArr(this.moneyBuildInfo.gameData.gameNbrMonths);
    }
    const savingsProcessed = createSavingsUpdateObj(this.newSavingsSw, this.moneyBuildInfo.savingsInfo, 
        this.savingsInfoArr, this.moneyBuildInfo.gameData._id, this.moneyBuildInfo.gameData.currentGameDate,
        this.companyMatchRate, this.moneyBuildInfo.gameData.gameNbrMonths, this.CDList, this.savingsLevel);
    this.moneyBuildInfo.savingsInfo = savingsProcessed.savingsInfoObj;
    this.savingsTranArr = savingsProcessed.savingsTranArr;
    this.savingsCashAmt = savingsProcessed.cashAmt;
    this.updateSavingsAmounts();
    this.props.setMoneyBuildInfo(this.moneyBuildInfo.savingsInfo, 'savingsInfo');
    this.updateGameData();
  
}

updateGameData(){  
    if (this.state.eventTracker === true){
        this.saveEventTracker();
    }
    let cashAmt = (+this.moneyBuildInfo.gameData.currentCash + +this.savingsCashAmt).toFixed(2);
    let index = 
        this.moneyBuildInfo.gameData.unlockedFeatures.findIndex(element => element.featureName === 'moneyBuilder');
    const currentLevel = determineSavingsLevel(this.moneyBuildInfo.savingsInfo);
    if (currentLevel === this.moneyBuildInfo.gameData.unlockedFeatures[index].level){
        if (this.totalNewMonthlyAmt > 0 || this.totalOneTimeAmt > 0){
            this.moneyBuildInfo.gameData.unlockedFeatures[index].setup = "active";
        }else{
            this.moneyBuildInfo.gameData.unlockedFeatures[index].setup = "inactive";
        }
    }
    let iconTable = this.moneyBuildInfo.gameData.iconTable;
    let startIdx = iconTable.length - 1;
    for (let i=startIdx; i>=0; i--){
        if (iconTable[i].iconName === "moneyBuilder" ||
            iconTable[i].iconName === "savingsGTIncome" ||
            iconTable[i].iconName === "savingsTransfer"){
           iconTable.splice(i,1);
           break;
        }
    }
    this.moneyBuildInfo.gameData.currentCash = cashAmt;
    this.currentCash = this.moneyBuildInfo.gameData.currentCash;
    this.moneyBuildInfo.gameData.iconTable = iconTable;
    this.props.setMoneyBuildInfo(this.moneyBuildInfo.gameData, 'gameData');
    this.bodyObj = {
        "currentCash": cashAmt,
        "unlockedFeatures": this.moneyBuildInfo.gameData.unlockedFeatures,
        "iconTable": iconTable
    };
    this.updateUnlockedFeatures();
}

updateUnlockedFeatures(){
    const funcName = "updateUnlockedFeatures";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
       {method:'PUT', headers: this.state.headers,
       body: JSON.stringify(this.bodyObj)})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
            const output = JSON.parse(data);
            const statusCode = output.statusCode;
            if (statusCode === 200){
                //  successful update of gameData
                this.closeSavingsConfirmModal();
                this.setState({step: "complete"});
            }else{
                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                    status: statusCode, message: output.body.message};
                this.props.processError(errorObj);
            }
        });
        }
    });
}

saveEventTracker(){
    let cashChgAmt = (+this.oneTimeAmt + +this.xferAmt).toFixed(2);
    cashChgAmt = cashChgAmt.toString();
    const savingsChangeInfo = {unlockedFeature: "Savings",
         cashChg: cashChgAmt,
         conditionTable: this.newConditionsTable,
         assetTable: this.moneyBuildInfo.gameData.assetTable, 
         expenseTable: this.moneyBuildInfo.gameData.expenseTable,
         loanTable: this.moneyBuildInfo.gameData.loanTable, 
         moodPoints: "0"};
    const dataObject = createEventTrackerUpdateObject("UnlockedFeatures", 
        "SetUpSavings", this.moneyBuildInfo.gameData, savingsChangeInfo, this.moneyBuildInfo.creditCardInfo);

    const funcName = "saveEventTracker";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {
        method:'post',
        headers: this.state.headers,
        body: JSON.stringify(dataObject)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                       // update of event tracker was successful
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: dataObject};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

updateSavingsAmounts(){
    const funcName = "updateSavingsAmts";
    let savingsBodyObj = {savingsObj: this.moneyBuildInfo.savingsInfo, savingsTranArr: this.savingsTranArr};
    const urlParm = "?savingsClass=" + this.savingsClass;
    if (this.savingsClass === "retirement"){
        savingsBodyObj = {...savingsBodyObj, currentPriceArr: this.currentPriceArr}
    }
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {method:'PUT', headers: this.state.headers, 
        body: JSON.stringify(savingsBodyObj)})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.props.setMoneyBuildInfo(output.body, 'savingsInfo');
                    this.prepareForDisplay();
                    this.props.checkGameAchievements("savings");
                    this.props.reloadSavings();
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, 
                        errorObject: this.moneyBuildInfo.savingsInfo};
                    this.props.processError(errorObj);
                }
            });
            }
        });
}
    
}

export default  connect(mapStateToProps, mapDispatchToProps)(SetupSavings);